import React from 'react';

export default function Text(props) {
  const c = props.show;
  const d = props.direction;
  const p = props.prev;
  const n = props.next;
  const e = [];

  // if there is current, next or prev content

  var x;
  if (c && (c !== "no")){
    x = c;
    createJSX();
  } else if (p && (p !== "no")) {
    x = p;
    createJSX();
  } else if (n && (n !== "no")) {
    x = n;
    createJSX();
  }

  // create text jsx depending on content.js
  function createJSX(){
    for (let i = 0; i < x.length; i++) {
      if (x[i].type === 'p') {
        e.push(<p className={x[i].class} key={'text-'+i}>{x[i].string}</p>)
      } else if (x[i].type === 'h2') {
        e.push(<h2 className={x[i].class} key={'text-'+i}>{x[i].string}</h2>)
      } else if (x[i].type === 'h1') {
        e.push(<h1 className={x[i].class} key={'text-'+i}>{x[i].string}</h1>)
      } else if (x[i].type === 'div-p') {
        e.push(<div className={x[i].class + 'Wrapper'} key={'text-'+i}>
          <p className={x[i].class}>{x[i].string}</p></div>)
      } else if (x[i].type === 'a') {
        e.push(<span className={x[i].class} key={'text-'+i}><a href={x[i].url} target="_blank"  rel="noopener noreferrer">{x[i].string}</a></span>)
      } else if (x[i].type === 'span') {
        e.push(<span className={x[i].class} key={'text-'+i}>{x[i].string}</span>)
      } else if (x[i].type === 'br') {
        e.push(<br></br>)
      } else {
        e.push(<p className={x[i].class} key={'text-'+i}>wrong type</p>)
      }
    }
  }

  if (c && (c !== "no") && (d === "next") && n) {
    return <div className="Text"><div className={"TextWrapper page"+props.page}>{e}</div></div>
  } else if (p && (p !== "no") && (d === 'next')) {
    return <div className="Text"><div className={"TextWrapper nextOut page"+props.page}>{e}</div></div>
  } else if (c && (c !== "no") && p) {
    return <div className="Text"><div className={"TextWrapper nextIn page"+props.page}>{e}</div></div>
  } else if (n && (n !== 'no') && (c === "no") && (d === 'prev')) {
    return <div className="Text delayHide"><div className={"TextWrapper prevOut page"+props.page}>{e}</div></div>
  } else if (c && (c !== "no") && (d === 'prev')) {
    return <div className="Text"><div className={"TextWrapper prevIn page"+props.page}>{e}</div></div>
  } else {
    return null;
  }

};
